// Vue
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
// Template
import template from "./template.vue";

@Component({
  mixins: [template],
})
export default class Solution extends Vue {
  @Prop()
  konsi!: object;

  @Prop()
  translation!: object;
}
